"use client";

import { useEffect } from "react";
import { captureErrorBoundary } from "@/lib/utils/captureErrorBoundary";
import Link from "next/link";

export default function FAQError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureErrorBoundary(error, "faq", "/about-us/faq");
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center p-8 max-w-md">
        <h2 className="text-3xl font-['Font-Bold'] text-(--text-headline) mb-4">
          FAQ unavailable
        </h2>
        <p className="text-(--text-muted) mb-6">
          We couldn&apos;t load the FAQ. Please try again or contact us directly with your questions.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-(--gold) text-(--text-on-gold) rounded-lg hover:opacity-90 transition-opacity font-semibold"
          >
            Try again
          </button>
          <Link
            href="/connect/contact"
            className="px-6 py-3 bg-(--purple) text-(--gold) rounded-lg hover:opacity-90 transition-opacity font-semibold"
          >
            Contact us
          </Link>
        </div>
      </div>
    </div>
  );
}
